/* eslint-disable */
export default {
  dncAlert: 'Tämä yhteystieto on Älä soita ‑luettelossa.',
} as const;

// @key: @#@"dncAlert"@#@ @source: @#@"This contact is on a Do Not Call list."@#@
